import React, { useState, useMemo } from "react";
import styles from "./holiday-calendar.module.css";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import { Modal, Typography } from "antd";
import SVGIcon from "../../../../constants/SVGIcon";
import StatusChip from "../../../../components/status-chip/status-chip";
import { capitalizeFirstLetter } from "../../../../utils/format-text/fomat-text";

const localizer = momentLocalizer(moment);

const HolidayCalendar = ({
  eventData = [],
  dateValue = new Date(),
  height = 400,
  views = ["month"],
  defaultView = "month",
  defaultDate = new Date(),
  toolbar = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);

  const formattedEvents = useMemo(() => {
    return eventData.map((event) => {
      const date = moment(event.date, "YYYY-MM-DD").toDate();
      return {
        ...event,
        title: event.reason,
        start: date,
        end: date,
        allDay: true,
      };
    });
  }, [eventData]);

  const eventPropGetter = () => ({
    style: {
      border: "0.5px solid #EBEBEB",
      backgroundColor: "#FFF",
      boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.10)",
      padding: "4px",
      fontWeight: 500,
      fontSize: "12px",
      color: "#000",
      margin: "0px 10px 0px 10px",
      width: "90%",
      alignItems: "center",
    },
  });

  const handleSelectEvent = (event) => {
    setSelectedHoliday(event);
    setModalOpen(true);
  };

  return (
    <>
      <Calendar
        localizer={localizer}
        events={formattedEvents}
        startAccessor="start"
        endAccessor="end"
        views={views}
        defaultView={defaultView}
        date={dateValue}
        defaultDate={defaultDate}
        eventPropGetter={eventPropGetter}
        toolbar={toolbar}
        onSelectEvent={handleSelectEvent}
        selectable
        components={{
          event: ({ event }) => (
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span
                style={{
                  display: "flex",
                  width: "34px",
                  height: "24px",
                  padding: "5px 8px",
                  alignitems: "center",
                  borderRadius: "7px",
                  background:
                    "linear-gradient(0deg, rgba(0, 133, 255, 0.10) 0%, rgba(0, 133, 255, 0.10) 100%), #FFF",
                }}
              >
                <SVGIcon
                  name="flag-icon"
                  width="16"
                  height="18"
                  className="anticon"
                />
              </span>
              {event.reason}
            </span>
          ),
        }}
        style={{ height }}
      />

      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        title={<div className={styles.title}>Holiday Detail</div>}
        width={500}
      >
        <div className={styles.modal_card}>
          {selectedHoliday && (
            <div>
              <div className={styles.card_header}>
                <div className={styles.header_left}>
                  <span className={styles.icon_bg}>
                    <SVGIcon
                      name="flag-icon"
                      width="16"
                      height="18"
                      className="anticon"
                    />
                  </span>
                  <Typography className={styles.card_title}>
                    {selectedHoliday?.reason}
                  </Typography>
                </div>
                <StatusChip status={selectedHoliday?.status} />
              </div>
              <div className={styles.below_card}>
                <div className={styles.row}>
                  <span className={styles.label}>Holiday Type:</span>
                  <span className={styles.sub_label}>
                    {capitalizeFirstLetter(selectedHoliday.type)}
                  </span>
                </div>
                <div className={styles.row}>
                  <SVGIcon
                    name="calendar-icon"
                    width="22"
                    height="22"
                    className="anticon"
                  />
                  <span className={styles.date_title}>Date:</span>
                  <span className={styles.date_title}>
                    {moment(selectedHoliday.date).format("Do MMMM, YYYY")}
                  </span>
                </div>
                <div className={styles.row}>
                  <SVGIcon
                    name="calendar-icon"
                    width="22"
                    height="22"
                    className="anticon"
                  />
                  <span className={styles.date_title}>Day:</span>
                  <span className={styles.date_title}>
                    {capitalizeFirstLetter(selectedHoliday.day_of_week)}
                  </span>
                </div>
                {selectedHoliday.description && (
                  <div className={styles.row}>
                    <span className={styles.label}>
                      {capitalizeFirstLetter(selectedHoliday.description)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default HolidayCalendar;
